import { i18n } from "@/lang";

export default class Characteristic {
  constructor() {
    this.keys = [
      {
        lang: i18n.locale,
        value: null
      }
    ];
    this.unit = null;
    this.dataType = null;
    this.category = null;
    this.shortcut = null;
    this.isCritical = false;
  }
}
